import api from '@/api'
import Report from '@/api/communique/report'
import types from '@/types'

export default interface CampaignDrillDownMetrics {
  publisher: string
  metric_type: string
  parent_metric: string | null
  value: number
  is_drill_down: boolean
}

export interface CampaignFetchParams {
  startDate?: string
  endDate?: string
  initiativeId?: string
  mediaTypes: string[]
  excludeLineItemIds?: string[]
  includeLineItemIds?: string
}

export class CampaignDrillDownMetricsModel {
  public async fetch({
    mediaTypes,
    startDate,
    endDate,
    initiativeId,
    excludeLineItemIds,
    includeLineItemIds,
  }: CampaignFetchParams) {
    return api('report.dashboards.ihmCampaign.v2.campaignSocialDrillDownMetrics')
      .params({
        media_types: mediaTypes,
        initiativeId,
        start_date: startDate,
        end_date: endDate,
        exclude_line_item_ids: excludeLineItemIds,
        include_line_item_ids: includeLineItemIds,
      })
      .cache(1000 * types.config.dashboardCacheSeconds())
      .jsonMust<Report<CampaignDrillDownMetrics>>()
  }
}
